import React from 'react';
import './index.css';
import ErrorPage from '../ErrorPage';
import { ConsentError } from '../../constants';
const { REACT_APP_JWT_EXPIRED, REACT_APP_JWT_TAMPERED, REACT_APP_JWT_AUTO_EXPIRED, REACT_APP_JWT_CONSENT_PROCESSED } =
  process.env;

class AuthError extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showError: REACT_APP_JWT_TAMPERED,
      partnerName: '',
    };
  }

  componentDidMount() {
    const { showError, partnerName } = this.props.location.state;
    if (typeof showError !== 'undefined' && showError !== null) {
      if (showError === 'expired') {
        this.setState({
          showError: REACT_APP_JWT_EXPIRED.replace('{}', partnerName),
        });
      } else if (showError === 'autoExpired') {
        this.setState({
          showError: REACT_APP_JWT_AUTO_EXPIRED.replace('{}', partnerName),
        });
      } else if (showError === 'consentProcessed') {
        this.setState({
          showError: REACT_APP_JWT_CONSENT_PROCESSED.replace('{}', partnerName),
        });
      } else if (showError === 'tampered') {
        this.setState({
          showError: REACT_APP_JWT_TAMPERED.replace('{}', partnerName),
        });
      }
    } else {
      this.setState({
        showError: REACT_APP_JWT_TAMPERED,
      });
    }
  }

  render() {
    return <ErrorPage subcode={ConsentError.accessDenied} />;
  }
}

export default AuthError;
